<template>
    <woot-modal :show.sync="show" :on-close="onClose">
      <div class="column content-box">
        <woot-modal-header :header-title="$t('ATTRIBUTES_MGMT.ADD.TITLE')" />

        <div>
          <div class="main-form">

            <div>
              <span class="span-label">
                <form @submit.prevent="addTable">
                  <woot-input class="input-text" v-model.trim="addTableComponents.name"  :error="$v.addTableComponents.name.$error
                ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR')
                : ''
                " :label="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.NAME')"
                      type="text" :placeholder="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.NAME')" />
                  <div class="field">
                    <woot-button
                    variant="clear"
                    size="small"
                    color-scheme="hollow"
                    class-names="grey-btn"
                    :icon="addTableComponents.company.visibility ? 'eye-show' : 'eye-hide'"
                    v-tooltip.top="$t('CUSTOM_ATTRIBUTES.FORM.VISIBILITY')"
                    @click.prevent="toggleVisibility('company')"
                  />
                    <woot-input class="input-text" v-model.trim="addTableComponents.company.name"
                    :type="addTableComponents.company.visibility ? 'text': 'password'" :placeholder="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.FIRST_FIELD')" :label="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.FIRST_FIELD')" />
                    <div class="block">
                      <label>{{ $t('CUSTOM_ATTRIBUTES.FORM.TYPE_LABEL') }}</label>
                      <select v-model="addTableComponents.company.type">
                  <option v-for="type in types" :key="type.id" :value="type.option">
                    {{ $t(`CUSTOM_ATTRIBUTES.FORM.TYPE.${type.label}`) }}
                  </option>
                </select>
                    </div>
                  </div>
                  <div class="field">
                    <woot-button
                    variant="clear"
                    size="small"
                    color-scheme="hollow"
                    class-names="grey-btn"
                    :icon="addTableComponents.client_code.visibility ? 'eye-show' : 'eye-hide'"
                    v-tooltip.top="$t('CUSTOM_ATTRIBUTES.FORM.VISIBILITY')"
                    @click.prevent="toggleVisibility('client_code')"
                  />
                    <woot-input class="input-text" v-model.trim="addTableComponents.client_code.name"
                      :type="addTableComponents.client_code.visibility ? 'text': 'password'" :placeholder="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.SECOND_FIELD')" :label="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.SECOND_FIELD')" />
                    <div class="block">
                      <label>{{ $t('CUSTOM_ATTRIBUTES.FORM.TYPE_LABEL')  }}</label>
                      <select v-model="addTableComponents.client_code.type">
                  <option v-for="type in types" :key="type.id" :value="type.option">
                    {{ $t(`CUSTOM_ATTRIBUTES.FORM.TYPE.${type.label}`) }}
                  </option>
                </select>
                    </div>
                  </div>
                  <div class="field">
                    <woot-button
                    variant="clear"
                    size="small"
                    color-scheme="hollow"
                    class-names="grey-btn"
                    :icon="addTableComponents.status.visibility ? 'eye-show' : 'eye-hide'"
                    v-tooltip.top="$t('CUSTOM_ATTRIBUTES.FORM.VISIBILITY')"
                    @click.prevent="toggleVisibility('status')"
                  />
                    <woot-input class="input-text" v-model.trim="addTableComponents.status.name"
                    :type="addTableComponents.status.visibility ? 'text': 'password'" :placeholder="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.THIRD_FIELD')" :label="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.THIRD_FIELD')" />
                    <div class="block">
                      <label>{{ $t('CUSTOM_ATTRIBUTES.FORM.TYPE_LABEL')  }}</label>
                      <select v-model="addTableComponents.status.type">
                  <option v-for="type in types" :key="type.id" :value="type.option">
                    {{ $t(`CUSTOM_ATTRIBUTES.FORM.TYPE.${type.label}`) }}
                  </option>
                </select>
                    </div>
                  </div>
                  <div class="field">
                    <woot-button
                    variant="clear"
                    size="small"
                    color-scheme="hollow"
                    class-names="grey-btn"
                    :icon="addTableComponents.monthly_fee.visibility ? 'eye-show' : 'eye-hide'"
                    v-tooltip.top="$t('CUSTOM_ATTRIBUTES.FORM.VISIBILITY')"
                    @click.prevent="toggleVisibility('monthly_fee')"
                  />
                    <woot-input class="input-text" v-model.trim="addTableComponents.monthly_fee.name"
                    :type="addTableComponents.monthly_fee.visibility ? 'text': 'password'" :placeholder="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.FOURTH_FIELD')" :label="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.FOURTH_FIELD')"/>
                    <div class="block">
                      <label>{{ $t('CUSTOM_ATTRIBUTES.FORM.TYPE_LABEL')  }}</label>
                      <select v-model="addTableComponents.monthly_fee.type">
                  <option v-for="type in types" :key="type.id" :value="type.option">
                    {{ $t(`CUSTOM_ATTRIBUTES.FORM.TYPE.${type.label}`) }}
                  </option>
                </select>
                    </div>
                  </div>
                  <div class="field">
                    <woot-button
                    variant="clear"
                    size="small"
                    color-scheme="hollow"
                    class-names="grey-btn"
                    :icon="addTableComponents.custom_field_first.visibility ? 'eye-show' : 'eye-hide'"
                    v-tooltip.top="$t('CUSTOM_ATTRIBUTES.FORM.VISIBILITY')"
                    @click.prevent="toggleVisibility('custom_field_first')"
                  />
                    <woot-input class="input-text" v-model.trim="addTableComponents.custom_field_first.name"
                    :type="addTableComponents.custom_field_first.visibility ? 'text': 'password'" :placeholder="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.CUSTOM_ONE')" :label="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.CUSTOM_ONE')"/>
                    <div class="block">
                      <label>{{ $t('CUSTOM_ATTRIBUTES.FORM.TYPE_LABEL')  }}</label>
                      <select v-model="addTableComponents.custom_field_first.type">
                  <option v-for="type in types" :key="type.id" :value="type.option">
                    {{ $t(`CUSTOM_ATTRIBUTES.FORM.TYPE.${type.label}`) }}
                  </option>
                </select>
                    </div>
                  </div>
                  <div class="field">
                    <woot-button
                    variant="clear"
                    size="small"
                    color-scheme="hollow"
                    class-names="grey-btn"
                    :icon="addTableComponents.custom_field_second.visibility ? 'eye-show' : 'eye-hide'"
                    v-tooltip.top="$t('CUSTOM_ATTRIBUTES.FORM.VISIBILITY')"
                    @click.prevent="toggleVisibility('custom_field_second')"
                  />
                    <woot-input class="input-text" v-model.trim="addTableComponents.custom_field_second.name"
                    :type="addTableComponents.custom_field_second.visibility ? 'text': 'password'" :placeholder="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.CUSTOM_TWO')" :label="$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.CUSTOM_TWO')"/>
                    <div class="block">
                      <label>{{ $t('CUSTOM_ATTRIBUTES.FORM.TYPE_LABEL')  }}</label>
                      <select v-model="addTableComponents.custom_field_second.type">
                  <option v-for="type in types" :key="type.id" :value="type.option">
                    {{ $t(`CUSTOM_ATTRIBUTES.FORM.TYPE.${type.label}`) }}
                  </option>
                </select>
                    </div>
                  </div>
                  <woot-button>
                  {{ $t('CUSTOM_ATTRIBUTES.FORM.CREATE') }}
                </woot-button>
                <woot-button variant="clear" @click.prevent="onClose">
                  {{ $t('CUSTOM_ATTRIBUTES.FORM.CANCEL') }}
                </woot-button>
                </form>
              </span>
              <div class="modal-footer">

              </div>
            </div>

          </div>
        </div>
      </div>
    </woot-modal>
  </template>

  <script>
  import alertMixin from 'shared/mixins/alertMixin';
import { minLength, required } from 'vuelidate/lib/validators';
import { GROUP_TYPES } from './constants';
import { mapGetters } from 'vuex';

  export default {
    mixins: [alertMixin],
    data() {
      return {
        values: [],
        options: [],
        show: true,
        types: GROUP_TYPES,
        isTouched: false,
        addTableComponents: {
          name: '',
          company: {
            name: this.$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.FIRST_FIELD'),
            visibility: true,
            type:'text'
          },
          client_code: {
            name: this.$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.SECOND_FIELD'),
            visibility: true,
            type:'text'
          },
          status: {
            name: this.$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.THIRD_FIELD'),
            visibility: true,
            type:'text'
          },
          monthly_fee: {
            name: this.$t('CUSTOM_ATTRIBUTES.FORM.DEFAULT_VALUES.FOURTH_FIELD'),
            visibility: true,
            type:'currency'
          },
          custom_field_first: {
            name: '',
            visibility: true,
            type:'text'
          },
          custom_field_second: {
            name: '',
            visibility: true,
            type:'text'
          },
        }
      };
    },
    computed: {
      ...mapGetters({
        uiFlags: 'getUIFlags',
        indexTab: 'attributes/getIndexTabAttributes',
      }),
      groupAttributes() {
        const customAttribute = this.$store.getters['attributes/getAttributesByModel'](
          'group_attribute'
        );
        return customAttribute
      },
    },
    validations: {
      addTableComponents: {
        name:{
          required,
          minLength: minLength(1),
        },
        company: {}

      }
    },

    methods: {
      toggleVisibility(fieldKey) {
      if (this.addTableComponents[fieldKey]) {
        this.addTableComponents[fieldKey].visibility = !this.addTableComponents[fieldKey].visibility;
      }
    },
      onClose(){
        this.$emit('on-close')
      },
      onTouch() {
        this.isTouched = true;
      },
      async addTable() {
        try {
        await this.$store.dispatch('attributes/create', {
          attributeType: 'group_table',
          name: this.addTableComponents.name,
          company: this.addTableComponents.company || {},
          client_code: this.addTableComponents.client_code || {},
          status: this.addTableComponents.status || {},
          monthly_fee: this.addTableComponents.monthly_fee || {},
          custom_field_first: this.addTableComponents.custom_field_first || {},
          custom_field_second: this.addTableComponents.custom_field_second || {},
        });
        this.onClose
      } catch (error) {
        console.error(`Erro ao processar`, error);
        throw error;
      }
      },
    },
  };
  </script>
  <style lang="scss" scoped>

  .field {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .field .input-text {
    flex-grow: 1;
  }

  .checkbox-container {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .checkbox {
    margin-top: 15px;
    margin-left: 5px;
    transform: scale(1.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }


  ::v-deep {
    .multiselect {
      margin-bottom: 0;
    }

    .multiselect__content-wrapper {
      display: none;
    }

    .multiselect--active .multiselect__tags {
      border-radius: var(--border-radius-normal);
    }

    .tabs {
      padding: 0;
    }

  }


  .main-form {
    margin-top: 1rem;
  }

  .span-label {
    display: block;
    margin: 0;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 1.8;
    color: var(--color-ink);
  }
  </style>
